'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('../../text/text');

var _text2 = _interopRequireDefault(_text);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartTooltip(_ref) {
  var payload = _ref.payload,
      title = _ref.title,
      _ref$elementsIds = _ref.elementsIds,
      elementsIds = _ref$elementsIds === undefined ? [] : _ref$elementsIds,
      _ref$filteredElements = _ref.filteredElementsIds,
      filteredElementsIds = _ref$filteredElements === undefined ? [] : _ref$filteredElements,
      _ref$elementLabels = _ref.elementLabels,
      elementLabels = _ref$elementLabels === undefined ? {} : _ref$elementLabels,
      formatValue = _ref.formatValue;

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _text2.default,
      { style: { color: '#989898' }, size: 'small', weight: 'bold' },
      title
    ),
    _react2.default.createElement(
      'div',
      null,
      elementsIds.map(function (elementId, index) {
        if (filteredElementsIds.includes(elementId)) {
          return _react2.default.createElement(
            _text2.default,
            {
              key: 'tooltip-item-' + elementId,
              size: 'small',
              style: { color: (0, _utils2.default)(index) }
            },
            elementLabels[elementId],
            formatValue ? formatValue(elementId, payload[elementId]) : payload[elementId]
          );
        }

        return null;
      })
    )
  );
}

ChartTooltip.propTypes = {
  payload: _propTypes2.default.object.isRequired,
  elementsIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  filteredElementsIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  title: _propTypes2.default.any.isRequired,
  elementLabels: _propTypes2.default.object.isRequired,
  formatValue: _propTypes2.default.func
};

exports.default = ChartTooltip;